module.exports = __webpack_public_path__ + "static/img/analise-sentimento-2.6d1a24f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/analise-sentimento-2.png
// module id = qLaV
// module chunks = 1